'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import {
  SvgCurrencyDollar,
  SvgPresentationChart2,
  SvgUsers,
} from '@/components/ui/icons'
import { useEffect, useState } from 'react'

const Impact = () => {
  const [region, setRegion] = useState('')

  useEffect(() => {
    const getLocation = async () => {
      const getLocation = await fetch('/api/location')
      const loc = await getLocation.json()
      setRegion(loc.countryTimezone)
    }
    getLocation()
  }, [])

  const isAmerica = () => {
    const countryRegion = region?.toLowerCase()
    return (
      countryRegion?.includes('america') || countryRegion?.includes('caribbean')
    )
  }

  return (
    <div className="pt-24 max-w-7xl w-full mx-auto px-6 lg:px-8">
      <FadeInStagger faster>
        <div className="max-w-3xl mx-auto self-stretch flex-col justify-start items-center gap-12 flex">
          <div className="flex-col justify-start items-start gap-5 flex">
            <div className="self-stretch flex-col justify-start items-center gap-3 flex">
              <FadeIn>
                <div className="p-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 flex">
                  <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                    <div className="text-center text-white text-sm font-medium  leading-5">
                      Our Focus
                    </div>
                  </div>
                </div>
              </FadeIn>

              <FadeIn>
                <h2 className="text-center text-white text-[36px] font-semibold leading-[44px]">
                  Real World Impact
                </h2>
              </FadeIn>
            </div>
            <FadeIn>
              <p className="text-center text-[#D0D5DD] text-xl font-normal leading-[30px] md:w-[768px]">
                At AI Forge, we are dedicated to supporting startups that are
                making a real-world impact through AI-driven solutions. Our
                intensive 12-week program is designed to equip founders with the
                skills, tools, and resources needed to launch successful AI
                startups.
              </p>
            </FadeIn>
          </div>
        </div>

        <div className="pt-16 self-stretch justify-start items-start gap-6  flex-col xl:flex-row flex">
          <div className="xl:w-[596px] xl:h-[412px] h-full p-6 bg-gradient-to-br from-neutral-900 to-black rounded-2xl border border-neutral-700 justify-start items-start gap-4 flex-col xl:flex-row xl:flex mb-3">
            <FadeIn className="text-white w-12 h-12 p-3 bg-white bg-opacity-10 rounded-lg border border-neutral-400 justify-center items-center flex">
              <SvgCurrencyDollar />
            </FadeIn>

            <div className="self-stretch xl:w-[596px]  w-full flex-col justify-start items-start gap-2 flex">
              <FadeIn>
                <h2 className="self-stretch text-white text-xl font-semibold leading-[30px] mt-4 xl:mt-0">
                  Financial Support
                </h2>
              </FadeIn>
              <FadeIn>
                <p
                  className="self-stretch  text-base font-normal leading-normal w-full xl:w-[484px]"
                  style={{ color: '#D0D5DD' }}
                >
                  As part of our incubator program, startups receive a
                  comprehensive package, which includes optional cash support.
                  Additionally, startups receive 100 hours of free developer or
                  data science time, 30 hours of UX/UI and design support,
                  financial model creation, full market research, and
                  identifying a variety of AI market opportunities.
                  <br />
                  <br />
                  But we don't stop there. We're not just offering support;
                  we're <br /> co-pilots on your startup journey. Our mission is
                  to help your dream take flight.
                </p>
              </FadeIn>
            </div>
          </div>

          <div className="w-full flex-col justify-start items-start gap-6 flex">
            <div className="self-stretch p-6 bg-gradient-to-br from-neutral-900 to-black rounded-2xl border border-neutral-700 justify-start items-start gap-4  flex-col xl:flex-row flex xl:h-[158px] mb-3 lg:mb-0">
              <FadeIn className="text-white w-12 h-12 p-3 bg-white bg-opacity-10 rounded-lg border border-neutral-400 justify-center items-center flex">
                <SvgPresentationChart2 />
              </FadeIn>
              <div className="grow shrink basis-0 flex-col justify-start items-start gap-5  h-auto">
                <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                  <FadeIn className="self-stretch text-white text-xl font-semibold leading-[30px]">
                    Intensive 12-week program
                  </FadeIn>
                  <FadeIn
                    className="self-stretch  text-base font-normal leading-normal"
                    style={{ color: '#D0D5DD' }}
                  >
                    Join a rigorous and hands-on 12-week program with over 40
                    training sessions designed to equip you with the skills,
                    tools, and resources necessary to launch a successful AI
                    startup.
                  </FadeIn>
                </div>
              </div>
            </div>

            <div className="self-stretch  xl:h-[230px] px-6 py-3 bg-gradient-to-br from-neutral-900 to-black rounded-2xl border border-neutral-700 justify-start items-start gap-4 flex flex-col xl:flex-row mb-3 ">
              <FadeIn className="text-white w-12 h-12 p-3 bg-white bg-opacity-10 rounded-lg border border-neutral-400 justify-center items-center flex">
                <SvgUsers />
              </FadeIn>
              <div className="grow shrink basis-0 flex-col justify-start items-start gap-5 ">
                <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                  <FadeIn className="self-stretch text-white text-xl font-semibold leading-[30px]">
                    Co-founder-like support
                  </FadeIn>
                  <FadeIn
                    className="self-stretch  text-base font-normal leading-normal"
                    style={{ color: '#D0D5DD' }}
                  >
                    Get personalized guidance and support from a team of
                    seasoned entrepreneurs who will act as mentors and
                    supporters, helping you navigate the challenges of starting
                    an AI company. They will provide valuable insights and
                    handle many of the complex tasks required to launch a
                    successful startup.
                  </FadeIn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FadeInStagger>
    </div>
  )
}
export default Impact
